import { render, staticRenderFns } from "./HouseholdIncome.vue?vue&type=template&id=895a94ac&scoped=true&"
import script from "./HouseholdIncome.vue?vue&type=script&lang=js&"
export * from "./HouseholdIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895a94ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('895a94ac')) {
      api.createRecord('895a94ac', component.options)
    } else {
      api.reload('895a94ac', component.options)
    }
    module.hot.accept("./HouseholdIncome.vue?vue&type=template&id=895a94ac&scoped=true&", function () {
      api.rerender('895a94ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/eicproducts/HouseholdIncome.vue"
export default component.exports